<template>
    <div v-if="promotedResource && !loading">
        <Resource
            :title="title"
            :img="img"
            :link="link"
            :inSameWindow="inSameWindow"
            :header="headerTitle"
        ></Resource>
    </div>
</template>

<script>
import i18n from '~/i18n';
import { PROMOTED_RESOURCE } from '~/router';
import UniversityService from '~/services/UniversityService';
import Resource from './Resource';

export default {
    name: 'FeaturedResource',
    components: { Resource },
    data() {
        return {
            headerTitle: i18n.t('components.smart.featuredResource.header'),
            title: i18n.t('components.smart.featuredResource.cta'),
            img:
                'https://content.gethighered.global/masterclasspromotion/20200602_Virtual_Conference.png',
            link: 'https://www.highered.global/live',
            promotedResource: PROMOTED_RESOURCE && window.location.hostname.includes('haigui'),
            loading: true,
            inSameWindow: false,
        };
    },
    mounted() {
        UniversityService.getCurrentSchoolData().then(res => {
            if (IS_PROD && res.subDomain === 'haigui') {
                this.headerTitle = i18n.t('components.smart.featuredResource.wechatSignupHeader');
                this.title = i18n.t('components.smart.featuredResource.wechatSignupCta');
                this.img =
                    'https://content.gethighered.global/miscellaneous/haigui_wechatSignup.jpg';
                this.link =
                    'https://content.gethighered.global/miscellaneous/haigui_wechatSignup.jpg';
                this.inSameWindow = false;
            }
            this.loading = false;
        });
    },
};
</script>

<style lang="css" scoped></style>
